import React, { PureComponent } from 'react';

interface PageButtonProps {
  value: number;
  onClick: (value: number) => void;
  selectedPageNumber: number;
}

export default class PageButton extends PureComponent<PageButtonProps> {

  render() {
    return (
      <button
          key={this.props.value}
        type="button"
        className={`btn btn-page-number ${this.props.selectedPageNumber === this.props.value ? 'btn-primary' : 'btn-outline-light'} mr-1`}
        onClick={() => (this.props.selectedPageNumber !== this.props.value ? this.props.onClick(this.props.value) : undefined)}
      >
        {this.props.value}
      </button>
    );
  }
}
